import { Injectable } from '@angular/core';
import { TileIpeValueComponent } from '../../../components/tile/tile-ipe-value/tile-ipe-value';
import type { CustomTileModel } from '../../../interfaces/Tile.interface';
import type { CustomTileProvider } from './custom-tile.provider';

@Injectable({
    providedIn: 'root'
})
export class TileIpeValueProvider implements CustomTileProvider {
    fillTileDescription(): CustomTileModel {
        throw Error('Not implemented');
    }

    getTileComponent() {
        return TileIpeValueComponent;
    }
}
